import { KLoggerFactory_instance34piadmnvwips as KLoggerFactory_instance } from './internal/KLoggerFactory.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KotlinLoggingClass;
function KotlinLogging() {
  if (KotlinLoggingClass === VOID) {
    class $ {
      a2g(name) {
        return KLoggerFactory_instance.a2g(name);
      }
    }
    initMetadataForObject($, 'KotlinLogging');
    KotlinLoggingClass = $;
  }
  return KotlinLoggingClass;
}
var KotlinLogging_instance;
function KotlinLogging_getInstance() {
  return KotlinLogging_instance;
}
//region block: init
KotlinLogging_instance = new (KotlinLogging())();
//endregion
//region block: exports
export {
  KotlinLogging_instance as KotlinLogging_instance32e31mxjasx6q,
};
//endregion

//# sourceMappingURL=KotlinLogging.mjs.map
